import { FC } from 'react'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../lib/analytics'
import { bulkOrderCategory } from '../constants'
import { BulkContainer } from '../containers/BulkContainer'

import { Container, OuterContainer, SelectedGender, UnselectedGender } from './styles'

export const GenderNav: FC = () => {
  const { currentGender, handleGenderChange } = BulkContainer.useContainer()
  const {
    collections: {
      genderNavSection: { womens, mens },
    },
  } = useTranslation()

  return (
    <OuterContainer>
      <Container>
        {currentGender === 'women' ? (
          <>
            <SelectedGender>{womens}</SelectedGender>
            <UnselectedGender
              role='button'
              tabIndex={0}
              onClick={() => handleGenderChange('men')}
              onKeyDown={e => e.key === 'Enter' && handleGenderChange('men')}
              {...trackEvent({
                category: bulkOrderCategory,
                action: 'change gender',
                value: 'men',
              })}
            >
              {mens}
            </UnselectedGender>
          </>
        ) : (
          <>
            <UnselectedGender
              role='button'
              tabIndex={0}
              onClick={() => handleGenderChange('women')}
              onKeyDown={e => e.key === 'Enter' && handleGenderChange('women')}
              {...trackEvent({
                category: bulkOrderCategory,
                action: 'change gender',
                value: 'women',
              })}
            >
              {womens}
            </UnselectedGender>
            <SelectedGender>{mens}</SelectedGender>
          </>
        )}
      </Container>
    </OuterContainer>
  )
}
